<div class="gfid-body profile-Setting" >
  <!-- Loader when hit the save/submit button -->
  <ng-template #customLoadingTemplate>
    <div class="custom-class-loader">
      <div class="spinner-container">
        <img src="assets/qwyn/icons/spinner.gif" alt="Loading" class="loader">
      </div>
    </div>
  </ng-template>
  <ngx-loading [show]="showSpinner" [config]="{ backdropBorderRadius: '3px' }"
    [template]="customLoadingTemplate"></ngx-loading>
  <form  class="h-100" [formGroup]="profileSettingForm">
    <div class="d-flex flex-row h-100">
      <!-- Responsive Design-->
      <p-tabView id='profileTabs' class="adminview " #profileTabs (onChange)="onTabChange($event)" [styleClass]="'admin-tabview'"
        [scrollable]="false"
        [style]="{'padding':'1em 0em','width':'100%','max-width':'1150px','margin-left': '16px', overflow: 'hidden', 'position': 'relative'}"
        [activeIndex]="actTabIdx">
        <p-tabPanel header="Preferences" class="tab-heading padding-left">
          <div class="d-flex flex-row mt-3 mrg-lef">
            <div class="w-100 d-flex flex-row align-items-start justify prefrence-dropdown-sontainer">
              <span class="preference">
                <label for="from" class="flex-grow outOfOffice">Default “From:” group</label>
              </span>
              <span class="w-55">
                <p-dropdown [styleClass]="'signatureDropdown drop-down group-details-inp drop-admin'"
                  optionLabel="name" formControlName="defaultGroup" [options]="defaultGroupList">
                </p-dropdown>
              </span>
            </div>
          </div>
          <div class="d-flex flex-row mt-3 mrg-lef">
            <div class="w-100 d-flex flex-row align-items-start justify prefrence-dropdown-sontainer">
              <span class="preference">
                <label for="from" class="flex-grow outOfOffice">Conversation View</label>
              </span>
              <span class="w-55">
                <p-dropdown [styleClass]="'signatureDropdown drop-down group-details-inp drop-admin'"
                  optionLabel="name" formControlName="conversationView" [options]="conversationViewList">
                </p-dropdown>
              </span>
            </div>
          </div>

          <div class="d-flex flex-row mt-3 mrg-lef">
            <div class="w-100 d-flex flex-row align-items-start justify prefrence-dropdown-sontainer">
              <span class="preference">
                <label for="from" class="flex-grow outOfOffice">Date Formatter</label>
              </span>
              <span class="w-55">
                <p-dropdown [styleClass]="'signatureDropdown drop-down group-details-inp drop-admin'"
                  optionLabel="name" formControlName="dateFormat" [options]="dateFormatList">
                </p-dropdown>
              </span>
            </div>
          </div>
          <div class="d-flex flex-row mt-3 mrg-lef">
            <div class="w-100 d-flex flex-row align-items-start justify prefrence-dropdown-sontainer">
              <span class="preference">
                <label for="from" class="flex-grow outOfOffice">Default Editor Font Family</label>
              </span>
              <span class="w-55">
                <p-dropdown [styleClass]="'signatureDropdown drop-down group-details-inp drop-admin'"
                  optionLabel="name" formControlName="defaulttinyMCEFontFamily" [options]="tinyMCEFontFamilyList">
                </p-dropdown>
              </span>
            </div>
          </div>
          <div class="d-flex flex-row mt-3 mrg-lef">
            <div class="w-100 d-flex flex-row align-items-start justify prefrence-dropdown-sontainer">
              <span class="preference">
                <label for="from" class="flex-grow outOfOffice">Default Editor Font Size</label>
              </span>
              <span class="w-55">
                <p-dropdown [styleClass]="'signatureDropdown drop-down group-details-inp drop-admin'"
                  optionLabel="name" formControlName="defaulttinyMCEFontSize" [options]="tinyMCEFontSizeList">
                </p-dropdown>
              </span>
            </div>
          </div>
          <div class="d-flex flex-row mt-3 mrg-lef">
            <div class="w-100 d-flex flex-row align-items-start ">
              <span class="preference">
                <label for="from" class="flex-grow outOfOffice pt5">Secure External Mails</label>
              </span>
              <span class="radio-preference-notification">
                <p-inputSwitch formControlName="sendSecureEmail" [styleClass]="'advance-inputSwitch mar-0'"></p-inputSwitch>
              </span>
            </div>
          </div>
          <div class="d-flex flex-row mt-3 mrg-lef">
            <div class="w-100 d-flex flex-row align-items-start ">
              <span class="preference">
                <label for="disableAutoCompleteSwitch" class="flex-grow outOfOffice pt5">Disable Recipient Auto-Suggest</label>
              </span>
              <span class="radio-preference-notification">
                <p-inputSwitch id="disableAutoCompleteSwitch" formControlName="disableAutoComplete"
                  [styleClass]="'advance-inputSwitch mar-0'"></p-inputSwitch>
              </span>
            </div>
          </div>
          <div class="d-flex flex-row mt-3 mrg-lef">
            <div class="w-100 d-flex flex-row align-items-start ">
              <span class="preference">
                <label for="from" class="flex-grow outOfOffice pt5">Prompt for Attachment Password</label>
              </span>
              <span class="radio-preference-notification">
                <p-inputSwitch formControlName="attachmentPwdProtectionFlag"
                  [styleClass]="'advance-inputSwitch mar-0'"></p-inputSwitch>
              </span>
            </div>
          </div>
          <div class="d-flex flex-row mt-3 mrg-lef">
            <div class="w-100 d-flex flex-row align-items-start ">
              <span class="preference">
                <label for="from" class="flex-grow outOfOffice pt5">Disclaimer for New Inquiry</label>
              </span>
              <span class="radio-preference-notification">
                <p-inputSwitch formControlName="disclaimerInq" [styleClass]="'advance-inputSwitch mar-0'"></p-inputSwitch>
              </span>
            </div>
          </div>
          <div class="d-flex flex-row mt-3 mrg-lef">
            <div class="w-100 d-flex flex-row align-items-start ">
              <span class="preference">
                <label for="from" class="flex-grow outOfOffice pt5">Disclaimer for Reply | Reply All | Forward</label>
              </span>
              <span class="radio-preference-notification">
                <p-inputSwitch formControlName="disclaimerRply" [styleClass]="'advance-inputSwitch mar-0'"></p-inputSwitch>
              </span>
            </div>
          </div>
          <div class="d-flex flex-row mt-3 mrg-lef" *ngIf="isSymphonyEnabled">
            <div class="w-100 d-flex flex-row align-items-start ">
              <span class="preference">
                <label for="from" class="flex-grow outOfOffice pt5">Enable Symphony</label>
              </span>
              <span class="radio-preference-notification">
                <p-inputSwitch formControlName="enableSymphony" [styleClass]="'advance-inputSwitch mar-0'"></p-inputSwitch>
              </span>
            </div>
          </div>
          <div class="d-flex flex-row mt-3 mrg-lef" *ngIf="isTaskizeEnabled">
            <div class="w-100 d-flex flex-row align-items-start ">
              <span class="preference">
                <label for="from" class="flex-grow outOfOffice pt5">Enable Taskize</label>
              </span>
              <span class="radio-preference-notification">
                <p-inputSwitch formControlName="enableTaskize" [styleClass]="'advance-inputSwitch mar-0'"></p-inputSwitch>
              </span>
            </div>
          </div>


        </p-tabPanel>

        <p-tabPanel header="Notifications" class="tab-heading padding-left"
          [ngClass]="{
            'notifications_panel': showBrowserNotificationInstructions,
            'notification_panel_disabled': !showBrowserNotificationInstructions
          }"
        >
          <div class="notification_title_div">
            <h3>Enable In App Notifications</h3>
          </div>
          <div class="notification-tab">
            <div class="d-flex flex-row mt-2 mrg-lef">
              <div class="w-100 d-flex flex-row align-items-start">
                <span class="preference">
                  <label for="from" class="flex-grow outOfOffice pt5">Escalation</label>
                </span>
                <span class="radio-preference-notification">
                  <p-inputSwitch formControlName="esclation" [styleClass]="'advance-inputSwitch mar-0'"></p-inputSwitch>
                </span>
              </div>
            </div>
            <div class="d-flex flex-row mt-2 mrg-lef">
              <div class="w-100 d-flex flex-row align-items-start">
                <span class="preference">
                  <label for="from" class="flex-grow outOfOffice pt5">Approve/Reject</label>
                </span>
                <span class="radio-preference-notification">
                  <p-inputSwitch formControlName="approval" [styleClass]="'advance-inputSwitch mar-0'"></p-inputSwitch>
                </span>
              </div>
            </div>
            <div class="d-flex flex-row mt-2 mrg-lef">
              <div class="w-100 d-flex flex-row align-items-start">
                <span class="preference">
                  <label for="from" class="flex-grow outOfOffice pt5">Snooze</label>
                </span>
                <span class="radio-preference-notification">
                  <p-inputSwitch formControlName="snooze" [styleClass]="'advance-inputSwitch mar-0'"></p-inputSwitch>
                </span>
              </div>
            </div>
            <div class="d-flex flex-row mt-2 mrg-lef">
              <div class="w-100 d-flex flex-row align-items-start">
                <span class="preference">
                  <label for="from" class="flex-grow outOfOffice pt5">FollowUp</label>
                </span>
                <span class="radio-preference-notification">
                  <p-inputSwitch formControlName="followUp" [styleClass]="'advance-inputSwitch mar-0'"></p-inputSwitch>
                </span>
              </div>
            </div>


            <div class="d-flex flex-row mt-2 mrg-lef" *ngIf="isSymphonyEnabled &&
            userDataService.loggedInUserInfo.isSymphonyEnabledForUser == 'Y'">
              <div class="w-100 d-flex flex-row align-items-start">
                <span class="preference">
                  <label for="from" class="flex-grow outOfOffice pt5">Symphony</label>
                </span>
                <span class="radio-preference-notification">
                  <p-inputSwitch formControlName="symphony" [styleClass]="'advance-inputSwitch mar-0'"></p-inputSwitch>
                </span>
              </div>
            </div>
          </div>
          <div class="notification_title_div">

            <div class="d-flex flex-row gap-3 align-items-center learn-more-button-container"><h3>Browser Notifications</h3> <button class="notification_learn_more_button" (click)="showNotificationsModal()"><img class="iconWithHover" src='assets/Inbox/secondaryIconhover.svg'
              alt='Learn more button'
              > Learn More</button></div>
            

            <p-dialog
            [(visible)]="browserNotificationHelp"
            [modal]="true"
            [styleClass]="'showBrowserNotificationInstructionsModal'"
            [style]="{'top':'120px !important','border':'1px solid #002d72','background':'#fff'}"
            appendTo="body"
            showHeader="true"
            [resizable]="false"
            closable="false"
          >
            <p-header>
              <div
                class="d-flex flex-row align-items-center justify-content-between"
                style="margin-left: 15px"
              >
                <div class="header" style="width: 100%;">
                  <div class="d-flex flex-row align-items-center justify-content-between">
                    <div>
                      <span style="font-size: 16px;color:#FFFFFF; font-family: OpenSansSemiBold, sans-serif; line-height: 21.79px; font-weight: 600;">
                        Enable Browser Notifications
                      </span>
                    </div>
                  <div>
                    <button type="button" (click)="hideNotificationsModal()" class="d-flex flex-row close qma-text"
                      style="margin: 0px 6px 0px 0px;">
                      <img src="assets/qwyn/icons/close-grey.svg" alt="Close">
                    </button>
                  </div>
                  </div>
                </div>
              </div>
            </p-header>
            <div class="preferenceInputContainer">
              <div *ngIf="os === 'MacOS' && browserName !== 'Firefox' && browserName !== 'Unknown' && browserName !== 'Arc'" for="from" class="notification_info_label mt-2 mb-3">
                <span class="fontBold">For macOS:</span> Please follow the instructions below: 
                <div class="instructions-container">
                  <ol>
                      <li>
                          Click <strong>Allow</strong> when the "Show notifications" popup is displayed in your browser.
                          
                          <ol class="sub-list">
                            <li>If the popup does not appear, click on the <strong>Adjust Settings</strong> icon next to the url in the address bar, and then toggle notifications <strong>ON</strong>.</li>
                            </ol>
                      </li>
                      <li>
                          Open your "System Settings" <img src="assets/qwyn/icons/chevron-right.svg" class="chevron_icon" alt="chevron"  /> Select "Notifications" <img src="assets/qwyn/icons/chevron-right.svg" class="chevron_icon" alt="chevron" /> In your Notification Centre, set "Show previews" to <em>Always</em> or <em>When Unlocked</em> <img src="assets/qwyn/icons/chevron-right.svg" class="chevron_icon" alt="chevron" /> Find "<strong>{{ browserDisplayName }}</strong>" from the "Application Notifications" list, and select it. <img src="assets/qwyn/icons/chevron-right.svg" class="chevron_icon" alt="chevron" /> Turn the main toggle switch <strong>ON</strong> to allow notifications <img src="assets/qwyn/icons/chevron-right.svg" class="chevron_icon" alt="chevron" /> Set notification type to <strong>Alerts</strong>.
                      </li>
                      <li>
                          Please ensure "<strong>Do not Disturb</strong>" is disabled.
                      </li>
                  </ol>
                </div>
              </div>
              <div *ngIf="os === 'MacOS' && (browserName == 'Firefox' || browserName == 'Unknown' || browserName == 'Arc')" for="from" class="notification_info_label mt-2 mb-3">
                <span class="fontBold">For macOS:</span> Please follow the instructions below: 
                
                <div class="instructions-container">
                  <ol>
                      <li>
                          Click <strong>Allow</strong> when the "Show notifications" popup is displayed in your browser.
                          
                          <ol class="sub-list">
                            <li>If the popup does not appear, click on the <strong>Adjust Settings</strong> icon next to the url in the address bar, and then toggle notifications <strong>ON</strong>.</li>
                            </ol>
                      </li>
                      <li>
                          Open your "System Settings" <img src="assets/qwyn/icons/chevron-right.svg" class="chevron_icon" alt="chevron" /> Select "Notifications" <img src="assets/qwyn/icons/chevron-right.svg" class="chevron_icon" alt="chevron" /> In your Notification Centre, set "<strong>Show previews</strong>" to <em>Always</em> or <em>When Unlocked</em>.
                      </li>
                      <li>
                          Please ensure "<strong>Do not Disturb</strong>" is disabled.
                      </li>
                  </ol>
                </div>
              </div>
              <div *ngIf="os === 'Windows'" for="from" class="notification_info_label mt-2 mb-3">
                <span class="fontBold">For Windows 10/11:</span> Please follow the instructions below:

                <div class="instructions-container">
                  <ol>
                      <li>
                          Click <strong>Allow</strong> when the "Show notifications" popup is displayed in your browser.

                          <ol class="sub-list">
                              <li>If the popup does not appear, click on the <strong>View Site Information</strong> icon (typically a padlock or tune icon) next to the url in the address bar, and then set notifications to <strong>Allow</strong>.</li>
                          </ol>
                      </li>
                      <li>
                          Open "Windows Settings" <img src="assets/qwyn/icons/chevron-right.svg" class="chevron_icon" alt="chevron" /> Select "Notifications & Actions" and ensure "<em>Get Notifications from apps and other senders</em>" is turned <strong>ON</strong>.
                      </li>
                      <li>
                          Click on the browser of your choosing (e.g. Google Chrome, Microsoft Edge etc.) in the Notification senders' list and ensure "<em>Show Notification Banners</em>" and "<em>Show Notifications in Action Center</em>" are both checked <strong>ON</strong>.
                      </li>
                      <li>
                          Please ensure "<strong>Do not Disturb</strong>" (or "Focus assist" in older Windows versions) is disabled.
                      </li>
                  </ol>
                </div>
              </div>
            </div>

            <div style="width: 100% ; display: block; margin-top: 10px; margin-bottom: 10px;">
              <div class="d-flex flex-row"></div>
              <div class="buttonWrap">
                <button type="reset" class="btn clear-btn me-4" (click)="hideNotificationsModal()">Cancel</button>
                <button type="submit" class="btn search-btn" (click)="hideNotificationsModal()">Ok</button>
              </div>
            </div>
          </p-dialog>
        </div>

          <div class="notification-tab">
            <div class="d-flex flex-row mt-2 mrg-lef">
              <div class="w-100 d-flex flex-row align-items-start">
                <span class="preference">
                  <label for="from" class="flex-grow outOfOffice pt5">Notifications of New Inquiries</label>
                </span>
                <span class="radio-preference-notification">
                  <p-inputSwitch formControlName="notificationChecker_NewInq" [styleClass]="'advance-inputSwitch mar-0'"></p-inputSwitch>
                </span>
              </div>
            </div>

            <div class="d-flex flex-row mt-2 mrg-lef">
              <div class="w-100 d-flex flex-row align-items-start">
                <span class="preference">
                  <label for="from" class="flex-grow outOfOffice pt5">Notifications for Inquiries Assigned to You</label>
                </span>
                <span class="radio-preference-notification">
                  <p-inputSwitch formControlName="notificationChecker_AssignInq" [styleClass]="'advance-inputSwitch mar-0'"></p-inputSwitch>
                </span>
              </div>
            </div>

          </div>
        </p-tabPanel>
        <p-tabPanel header="Signature">
          <div class="profile-signature">
            <div >
              <div class="d-flex flex-column" style="margin-bottom: 10px;">
                <div *ngIf="saveSignMsg" class="error-banner" role="alert" aria-live="assertive">
                  <span>{{saveSignMsg}}</span>
                  <i class="pi pi-times-circle" aria-hidden="true"></i>
                </div>
                <div *ngIf="sf.newSignature.errors && saveSign">
                  <div *ngIf="sf.newSignature.errors.required" class="error-banner" role="alert" aria-live="assertive">
                    <span>Please enter a valid and unique signature name</span>
                    <i class="pi pi-times-circle" aria-hidden="true"></i>
                  </div>
                  <div *ngIf="sf.newSignature.errors.duplicate" class="error-banner" role="alert" aria-live="assertive">
                    <span>This signature name already exists. Please enter a different one to save.</span>
                    <i class="pi pi-times-circle" aria-hidden="true"></i>
                  </div>
                </div>
                <div *ngIf="showSignatureMsg" class="success-banner" role="status" aria-live="polite">
                  <span>{{signatureMsg}}</span>
                  <i class="pi pi-check-circle" aria-hidden="true"></i>
                </div>
              </div>
                <div class="d-flex flex-row  mb">
                  <div class="signatureNameSection">
                    <span>
                      <div  class="flex-grow signatureNameLabel">Signature Name</div>
                    </span>
                    <span  *ngIf="showIconsCheckBox">
                      <p-dropdown [styleClass]="'signatureDropdown drop-down group-details-inp drop-admin'"
                         optionLabel="name" formControlName="defaultSignature"
                        (onChange)="onSignatureChange()" [options]="signatures"  [ngClass]="{'signatureDropdown-open': isDropdownOpen}"
                        (onShow)="isDropdownOpen = true"
                        (onHide)="isDropdownOpen = false">
                      </p-dropdown>
                    </span>
                    <span  *ngIf="showIcons">
                      <input type="text" formControlName="newSignature" placeholder="Enter signature"
                        class="w-350 t-box inp-txt-mng group-details-input-mng" />
                    </span>
                    <div class=" signatureButtonSection">
                      <button type="button" class="signatureButton" *ngIf="!showIcons && !updatedSign" (click)="onCreateOrUpdate('create')">
                        <span>
                          <img class="qma-text right-side-signature-icon" src="assets/context/add-button.svg" alt="Create">
                        </span>
                        <span class="right-side-signature">Add New</span>
                      </button>
                      <!-- <div class="signatureButton" *ngIf="showIconsCheckBox" (click)="onCreateOrUpdate('modify')">
                        <span>
                          <img class="qma-text right-side-signature-icon" src="assets/context/edit-button.svg" alt="Modify">
                        </span>
                        <span class="right-side-signature">Modify</span>
                      </div> -->
                      <button type="button" class="signatureButton" *ngIf="showIconsCheckBox" (click)="onDeleteSignature()">
                        <span>
                          <img  src="assets/Inbox/attachmentDelete.svg" width="14" height="16" alt="Delete">
                        </span>
                        <span class="right-side-signature">Delete</span>
                      </button>
                      <!-- <div class="signatureButton" *ngIf="showIcons" (click)="onSaveSignature()">
                        <span>
                          <img class="qma-text right-side-signature-icon" src="assets/newMessage/save.svg" alt="Save">
                        </span>
                        <span class="right-side-signature">Submit</span>
                      </div> -->
                    </div>
                  </div>
                </div>
                <div class="signatureEditSection" *ngIf="signatures.length !==0 || showIcons">
                  <div class="d-flex flex-row mt-2 outOfOffice">
                    <editor-app [elementId]="'signature'" [toolbarOptions]="2" [height]="300" [fromNewMessage]="true" (change)="onCreateOrUpdate('modify')"  class="my-editor"></editor-app>
                  </div>
                  <div class="signatureEditButtonSection" *ngIf="showIconsCheckBox">
                    <div  class="signatureEditButton">
                      <span >
                        <!-- <p-inputSwitch formControlName="inInquiry" (onChange)="onChangeInquiry($event)"
                          [styleClass]="'advance-inputSwitch mar-0'"></p-inputSwitch> -->
                          <p-checkbox 
                            [formControl]="profileSettingForm.get('inInquiry')"
                            (onChange)="onChangeInquiry($event)" 
                            [binary]="true" 
                            [styleClass]="'advance-checkbox'">
                          </p-checkbox>

                      </span>
                      <span>
                        <label for="from" class="signatureEditButtonLabel">Include in New Inquiry</label>
                      </span>
                     
                    </div>
                    <div class="signatureDivider"></div>
                    <div  class="signatureEditButton">
                      <span >
                        <!-- <p-inputSwitch formControlName="inReply" (onChange)="onChangeReplyOrFwd($event)"
                          [styleClass]="'advance-inputSwitch mar-0'"></p-inputSwitch> -->
                          <p-checkbox 
                          [formControl]="profileSettingForm.get('inReply')"
                            (onChange)="onChangeReplyOrFwd($event)"
                            [binary]="true" 
                            [styleClass]="'advance-checkbox'">
                          </p-checkbox>
                      </span>
                      <span>
                        <label for="from" class="signatureEditButtonLabel">Reply | Reply All | Forward</label>
                      </span>
                      
                    </div>
                  </div>
                  
              </div>

            </div>
          </div>
          <!-- <p-footer class="footer-signature" *ngIf="actTabName === 'Signature'">
            <div class="backButton" *ngIf="showIcons" (click)="resetSignature()">
              <img  src="assets/profile/backchevron.svg" alt="Back" width="8" height="12">
              <span>Back</span>
            </div>
            <div class="signatureButtonWrap">
              <button
                pButton
                label="Reset"
                class="cancel-button"
                (click)="resetChanges()"
              ></button>
              <button
                pButton
                label="Submit"
                class="submit-button"
                (click)="onSaveUserProfile()"
              ></button>
            </div>
          </p-footer> -->
        </p-tabPanel>
        <p-tabPanel header="Templates">
          <div class="profile-template">
            <form [formGroup]="templateForm">
              <div class="d-flex flex-column" style="margin-bottom: 10px;">
                <div *ngIf="saveTmptMsg" class="error-banner" role="alert" aria-live="assertive">
                  <span>{{saveTmptMsg}}</span>
                  <i class="pi pi-times-circle" aria-hidden="true"></i>
                </div>
                <div *ngIf="tf.newTemplate.errors && saveTemplate">
                  <div *ngIf="tf.newTemplate.errors.required" class="error-banner" role="alert" aria-live="assertive">
                    <span>Please enter valid details for the name & content!</span>
                    <i class="pi pi-times-circle" aria-hidden="true"></i>
                  </div>
                  <div *ngIf="tf.newTemplate.errors.maxlength" class="error-banner" role="alert" aria-live="assertive">
                    <span>The template name should not contain more than 50 characters!</span>
                    <i class="pi pi-times-circle" aria-hidden="true"></i>
                  </div>
                  <div *ngIf="tf.newTemplate.errors.duplicate" class="error-banner" role="alert" aria-live="assertive">
                    <span>This template name already exists. Please enter a different one to save.</span>
                    <i class="pi pi-times-circle" aria-hidden="true"></i>
                  </div>
                </div>
                <div *ngIf="showTemplateMsg" class="success-banner" role="status" aria-live="polite">
                  <span>{{templateMsg}}</span>
                  <i class="pi pi-check-circle" aria-hidden="true"></i>
                </div>
                <div *ngIf="reqTmpltConent && saveTemplate" class="error-banner" role="alert" aria-live="assertive">
                   <span>Please enter valid details for the name & content!</span>
                   <i class="pi pi-times-circle" aria-hidden="true"></i>
                </div>
              </div>
              <div class="firstpart">
                <div class="mb3 signatureNameSection">
                  <span>
                    <label for="from" class="flex-grow signatureNameLabel">Template</label>
                  </span>
                  <span  *ngIf="showTempIcons">
                    <input type="text" formControlName="newTemplate" placeholder="Enter template"
                    class="w-350 t-box inp-txt-mng group-details-input-mng" />
                  </span>
                  <span  *ngIf="showTempIconsCheckBox">
                    <p-dropdown [styleClass]="'signatureDropdown drop-down group-details-inp drop-admin'" 
                      optionLabel="name" formControlName="defaultTemplate" (onChange)="onTemplateChange()"
                      [options]="userTemplateList"
                      [ngClass]="{'signatureDropdown-open': isDropdownOpen}"
                      (onShow)="isDropdownOpen = true"
                      (onHide)="isDropdownOpen = false">
                    </p-dropdown>
                  </span>
                  <div class="signatureButtonSection">
                    <button type="button" class="signatureButton" *ngIf="!showTempIcons && !isModifyTemplate" (click)="onCreateOrUpdateTemplate('create')">
                      <span>
                        <img class="qma-text right-side-signature-icon" src="assets/context/add-button.svg" alt="Create">
                      </span>
                      <span class="right-side-signature">Add New</span>
                    </button>
                    <!-- <div class="signatureButton" *ngIf="showTempIconsCheckBox" (click)="onCreateOrUpdateTemplate('modify')">
                      <span>
                        <img class="qma-text right-side-signature-icon" src="assets/context/edit-button.svg" alt="Modify">
                      </span>
                      <span class="right-side-signature">Modify</span>
                    </div> -->
                    <button type="button" class="signatureButton" *ngIf="showTempIconsCheckBox" (click)="onDeleteTemplate()">
                      <span>
                        <img  src="assets/Inbox/attachmentDelete.svg" width="14" height="16" alt="Delete">
                      </span>
                      <span class="right-side-signature">Delete</span>
                    </button>
                    <!-- <div class="signatureButton" *ngIf="showTempIcons" (click)="onSaveTemplate()">
                      <span>
                        <img class="qma-text right-side-signature-icon" src="assets/newMessage/save.svg" alt="Save">
                      </span>
                      <span class="right-side-signature">Submit</span>
                    </div> -->
                  </div>
                </div>
              </div>
              <div class="thirdpart">
                
                <div class="signatureEditSection" style="padding-top: 8px;">
                  <div class="  control-group">
                    <label for="to" class="min-width mt5" style="margin-top: 4px;">
                      <span class="to-cc-bcc">To:</span>
                    </label>
  
                    <p-autoComplete 
                      formControlName="toList" 
                      [suggestions]="filteredToUsersMultiple"
                      (completeMethod)="filterUsers($event)" 
                      [minLength]="3" 
                      field="text" 
                      [multiple]="true"
                      styleClass="override override-newmessage-autocomplete" 
                      class="w-100 bn  "
                      [(ngModel)]="toUsersList"
                      name="toUsersList"
                      (onFocus)="onCreateOrUpdateTemplate('modify')"
                      (onKeyUp)="onKeyUp($event, 'to')" 
                      (onBlur)="onBlur($event, 'to')">
                      <ng-template let-value pTemplate="selectedItem">
                        <span [ngClass]="contactTextStyle(value.value)"
                          class="p-autocomplete-token-label new-message-token">{{value.text}}</span>
                          <img  src="assets/Inbox/blueClose.svg" alt="Back" width="12" height="12" (click)="removeItem('to',value)"  >
                          
                      </ng-template>
                    </p-autoComplete>
                  </div>
                  <!-- merge recipient checkbox -->
                  <!-- <div class="d-flex flex-row align-items-center" style="margin-left: 5%;">
                    
                    <div class="">
                      <img src="assets/Inbox/info-icon.svg" class="icon-setting-out"
                        (mouseenter)="onShowInfo($event, meregerecipientsTooltip)"
                        (mouseleave)="onShowInfo($event, meregerecipientsTooltip)" alt="Info">
                      <p-overlayPanel [styleClass]="'icon-info-meregerecipientsTooltip'" [appendTo]="'body'"
                        #meregerecipientsTooltip [baseZIndex]="9999">
                        <div class="d-flex flex-row mb-0.3">
                          <span class="info-content">Uncheck to <span style="color: #0033cc;
                            font-style: italic;
                            font-family: 'OpenSans';">replace</span> recipients in reply</span>
                        </div>
                      </p-overlayPanel>
                    </div>
  
                  </div> -->
  
                  <div class=" control-group">
                    <label for="cc" class="min-width mt5" style="margin-top: 4px;">
                      <span class="to-cc-bcc">Cc:</span>
                    </label>
  
                    <p-autoComplete 
                    formControlName="ccList" 
                    [suggestions]="filteredToUsersMultiple"
                      (completeMethod)="filterUsers($event)" 
                      [minLength]="1" 
                      field="text" 
                      [multiple]="true"
                      styleClass="override override-newmessage-autocomplete" 
                      class="w-100 bn"
                      (onFocus)="onCreateOrUpdateTemplate('modify')"
                      (onKeyUp)="onKeyUp($event, 'cc')" 
                      (onBlur)="onBlur($event, 'cc')" 
                      [(ngModel)]="ccUsersList"
                      name="ccUsersList">
                      <ng-template let-value pTemplate="selectedItem">
                        <span [ngClass]="contactTextStyle(value.value)"
                          class="p-autocomplete-token-label new-message-token">{{value.text}}</span>
                          <img  src="assets/Inbox/blueClose.svg" alt="Back" width="12" height="12" (click)="removeItem('cc',value)"  >
                      </ng-template>
                    </p-autoComplete>
                  </div>
                  <div class=" control-group">
                    <label for="from" class="min-width mt5" style="margin-top: 4px;">
                      <span class="to-cc-bcc">Share to:</span>
                    </label>
                    <p-autoComplete 
                    formControlName="shareToGrpList" 
                    [suggestions]="filteredGroups"
                      (completeMethod)="filterGroups($event)" [minLength]="1" field="text" [multiple]="true"
                      styleClass="override override-newmessage-autocomplete" 
                      class="w-100 bn " placeholder="Start typing..." 
                      (onFocus)="onCreateOrUpdateTemplate('modify')"
                      >
                      <ng-template let-value pTemplate="selectedItem">
                        <span [ngClass]="contactTextStyle(value.value)"
                          class="p-autocomplete-token-label new-message-token">{{value.text}}</span>
                          <img  src="assets/Inbox/blueClose.svg" alt="Back" width="12" height="12" (click)="removeItem('group',value)"  >
                          
                      </ng-template>
                      <ng-template let-grp pTemplate="item">
                        <div class="ui-helper-clearfix">
                          <div class="search-text">{{grp.text}}</div>
                        </div>
                        
                      </ng-template>
                    </p-autoComplete>
                  </div>
                  <div class=" control-group">
                    <label for="subject" class="min-width mt5" style="margin-top: 4px;">
                      <span class="to-cc-bcc">Subject:</span>
                    </label>
                    <input type="text" formControlName="subject" placeholder="Subject"
                    (focus)="onCreateOrUpdateTemplate('modify')"
                    class="w-100 inputText" />
                  </div>
                  
                    <div class="d-flex flex-row mt-2 outOfOffice">
                    <editor-app [elementId]="'template'" [toolbarOptions]="2" [height]="150" [fromNewMessage]="true" (change)="onCreateOrUpdateTemplate('modify')" (keyupChange)="onCreateOrUpdateTemplate('modify')" class="my-editor"></editor-app>
                  </div>
                  <div class="signatureEditButtonSection" >
                    <div  class="signatureEditButton"  *ngIf="!showTempIcons">
                      <span >
                        <p-checkbox [formControl]="profileSettingForm.get('quickReply')" (onChange)="onChangeQuickReply($event)"
                        [styleClass]="'advance-checkbox'"
                        [binary]="true" ></p-checkbox>
                      </span>
                      <span>
                        <label for="from" class="signatureEditButtonLabel">Save as quick reply template</label>
                      </span>
                    
                    </div>
                    <div class="signatureDivider" *ngIf="!showTempIcons"></div>
                    <div  class="signatureEditButton">
                      <span >
                        <p-checkbox  formControlName="mergeRecipients" 
                        (onChange)="onCreateOrUpdateTemplate('modify')"
                        [styleClass]="'advance-checkbox'"
                        [binary]="true" ></p-checkbox>
                      </span>
                      <span>
                        <label for="from" class="signatureEditButtonLabel">Merge recipients in reply</label>
                      </span>
                    </div>
                  </div>
                </div>
                

              </div>
            </form>

            <!-- <div class="w-75 d-flex flex-row mt-4 fourthpart" *ngIf="!showTempIcons">
              <div class="d-flex flex-row">
                <span>
                  <label for="from" class="flex-grow outOfOffice pt5">Save as quick reply template</label>
                </span>
                <span class="pl3">
                  <p-inputSwitch formControlName="quickReply" (onChange)="onChangeQuickReply($event)"
                    [styleClass]="'advance-inputSwitch mar-0'"></p-inputSwitch>
                </span>
              </div>

              <div class="ms-auto mt-2">
                <img src="assets/Inbox/info-icon.svg" class="icon-setting-out"
                  (click)="onShowInfo($event, quickRplyInfo)" alt="Info">
                <p-overlayPanel [styleClass]="'icon-info'" [appendTo]="'body'" #quickRplyInfo [baseZIndex]="9999">
                  <div class="d-flex flex-row mb-0.3">
                    <span> <img class="default-color icon-setting-in" src="assets/Inbox/info-icon.svg"
                        alt="Info"></span>
                    <span class="info-content">{{quickReplyMsg}}</span>
                    <span> <img [src]="'assets/profile/quickReplyOptions.jpg'" alt="Reply"></span>
                  </div>
                </p-overlayPanel>
              </div>
            </div> -->

          </div>
          <!-- <div class="dBlock"><p-footer class="footer-signature" *ngIf="actTabName === 'Templates'">
            <div class="backButton" *ngIf="showTempIcons" (click)="resetTemplate()">
              <img  src="assets/profile/backchevron.svg" alt="Back" width="8" height="12">
              <span>Back</span>
            </div>
            <div class="signatureButtonWrap">
              <button
                pButton
                label="Reset"
                class="cancel-button"
                (click)="resetChanges()"
              ></button>
              <button
                pButton
                label="Submit"
                class="submit-button"
                (click)="onSaveUserProfile()"
              ></button>
            </div>
          </p-footer> </div> -->
          
        </p-tabPanel>
        <p-tabPanel header="Entitlements">
          <div style="width: 100%; padding-top: 50px; padding-left: 16px" >
              <ag-grid-angular
                      class="ag-theme-balham profile-entitlement-table"
                      [suppressHorizontalScroll]="true"
                      [rowHeight]="32"
                      [headerHeight]="40"
                      [columnDefs]="entitlementColumnDefs"
                      [rowData]="groupRoles"
                      [modules]="modules"
                      domLayout="autoHeight">
              </ag-grid-angular>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Out of office">
          <div class="profile-out-of-office">
            <div class="d-flex mt-4  align-items-center">
              <div class="outOfOffice1 width-360 flex-1">
                Enable Out of Office
              </div>
              <span class="ps-2" >
                <p-inputSwitch formControlName="outOfOffice" (onChange)="onOutOfOffice($event)"
                  [styleClass]="'advance-inputSwitch mar-0'"></p-inputSwitch>
              </span>
            </div>
            

            <div class="  d-flex flex-row mt-4  align-items-center">
              
              <div class="outOfOffice1 width-360  flex-1">
                Out of office Dates
              </div>
              <div>
                <div class="d-flex gap-3 date-container" >
                    <p-calendar 
                        dateFormat="dd/mm/yy" 
                        formControlName="startDt" 
                        [showOtherMonths]="true"
                        [hideOnDateTimeSelect]="true" 
                        [selectOtherMonths]="false" 
                        [monthNavigator]="true"
                        [yearNavigator]="true" 
                        [yearRange]="'2010:2030'"
                        [readonlyInput]="false"
                        [showIcon]="true" 
                        [minDate]="minimumDate" 
                        [disabledDays]="[0,6]" 
                        [disabled]="isOOO"
                        [iconDisplay]="'input'" 
                        inputId="icondisplay"
                        [appendTo]="'body'"
                        inputStyleClass="custom-width"
                        class="custom-calender"
                        [placeholder]="'DD/MM/YYYY'"                        
                        >
                        <ng-template pTemplate="inputicon">
                          <img 
                          src="assets/qwyn/icons/qwyn-calendar-xs.svg" 
                          alt="Calendar Icon" 
                          class="calender-icon"
                          width="20px"
                          (click)="calendar.inputfieldViewChild.nativeElement.focus()" />
                        </ng-template>
                    </p-calendar>
                    <p-calendar 
                        dateFormat="dd/mm/yy" 
                        formControlName="endDt" 
                        [showOtherMonths]="true"
                        [hideOnDateTimeSelect]="true" 
                        [selectOtherMonths]="false" 
                        [monthNavigator]="true"
                        [yearNavigator]="true" 
                        [yearRange]="'2010:2030'"
                        [readonlyInput]="false"
                        [showIcon]="true" 
                        [minDate]="minimumDate" 
                        [disabledDays]="[0,6]" 
                        [disabled]="isOOO"
                        [appendTo]="'body'"
                        [iconDisplay]="'input'" 
                        inputId="icondisplay1"
                        inputStyleClass="custom-width"
                        class="custom-calender"
                        [placeholder]="'DD/MM/YYYY'"
                        >
                        <ng-template pTemplate="inputicon">
                          <img 
                          src="assets/qwyn/icons/qwyn-calendar-xs.svg" 
                          alt="Calendar Icon" 
                          class="calender-icon"
                          width="20px"
                          (click)="calendar.inputfieldViewChild.nativeElement.focus()" />
                        </ng-template>
                    </p-calendar>

                  </div>    
                  <div>
                    <div *ngIf="psf.startDt.errors && isSubmitted" class="invalid-feedback">
                      <span *ngIf="psf.startDt.errors.required">From Date is required.</span>
                      <span *ngIf="psf.startDt.errors.prevDate">From date can't be less than today.</span>
                      <span *ngIf="psf.startDt.errors.nextDate">From date can't be greater than To date.</span>
                    </div>
                    <div *ngIf="psf.endDt.errors && isSubmitted" class="invalid-feedback">
                      <span *ngIf="psf.endDt.errors.required">To Date is required.</span>
                      <span *ngIf="psf.endDt.errors.prevDate">To date can't be less than From date or today.</span>
                      <span *ngIf="psf.endDt.errors.nextDate"></span>
                    </div>
                  </div>
              </div>
              
            </div>
            
            
            <!-- <div class="w-20 d-flex flex-row mt-4 hidden">
              <div class="d-flex flex-row flex-nowrap align-items-end w-50 pe-2">
                <label class="outOfOffice">From date:</label>
                <div class="w-50 ps-2 mb10">
                  <p-calendar dateFormat="mm/dd/yy" formControlName="startDt" [showOtherMonths]="true"
                    [hideOnDateTimeSelect]="true" [selectOtherMonths]="false" [monthNavigator]="true"
                    [yearNavigator]="true" [yearRange]="'2010:2030'"
                    [styleClass]="'advance-calender schedule-cal tab-calender-fix'" [readonlyInput]="false"
                    [showIcon]="true" [minDate]="minimumDate" [disabledDays]="[0,6]" [disabled]="isOOO">
                  </p-calendar>
                </div>
              </div>
              

              <div class="d-flex flex-row flex-nowrap align-items-end w-50 pe-2">
                <label class="outOfOffice">To date:</label>
                <div class="w-50 ps-2 mb10">
                  <p-calendar dateFormat="mm/dd/yy" formControlName="endDt" [showOtherMonths]="true"
                    [hideOnDateTimeSelect]="true" [selectOtherMonths]="false" [monthNavigator]="true"
                    [yearNavigator]="true" [yearRange]="'2010:2030'"
                    [styleClass]="'advance-calender schedule-cal tab-calender-fix'" [readonlyInput]="false"
                    [showIcon]="true" [minDate]="minimumDate" [disabledDays]="[0,6]" [disabled]="isOOO">
                  </p-calendar>
                </div>
              </div>
              
            </div> -->

            <div class="flex-row mt-4 borderooo mb-8">
              <editor-app [elementId]="'out-of-office'" [toolbarOptions]="2" [height]="300" [fromNewMessage]="true"  class="my-editor"></editor-app>
            </div>



            <div class="d-flex flex-row checkooo align-items-center">       
              <span class="ooo">
                <!-- <input type="checkbox" class="m-2" formControlName="notifyManager"> -->
                <p-checkbox 
                formControlName="notifyManager" 
                [binary]="true" 
                [styleClass]="'advance-checkbox mx-2'">
                </p-checkbox>
                <label for="from" class="flex-grow outOfOffice2 ">Notify Manager</label>
              </span>
              
              <!-- <span class="pl2">
                <input type="checkbox" class="m-2" formControlName="notifyManager">
                <p-inputSwitch
                        formControlName="notifyManager"
                        [styleClass]="'advance-inputSwitch mar-0'">
                </p-inputSwitch>
              </span> -->
            </div>

          </div>
        </p-tabPanel>

        <!-- Personal Information - Relates to Personal Calender and Personal Mailbox-->
        <p-tabPanel header="PERSONAL" class="tab-heading" *ngIf="isPersonalEnable">
          <span class="sub-title-info">This information is used for QWYN Personal Beta Testing only.</span>
          <div class="d-flex flex-row mt-3 mrg-lef">
            <div class="w-75 d-flex flex-row align-items-start">
              <span class="preference">
                <label for="from" class="flex-grow outOfOffice pt5">Enable Mail</label>
              </span>
              <span class="radio-notification">
                <p-inputSwitch formControlName="personalEmailSubscribed"
                  [styleClass]="'advance-inputSwitch mar-0'"></p-inputSwitch>
              </span>
            </div>
          </div>
          <div class="d-flex flex-row mt-3 mrg-lef">
            <div class="w-75 d-flex flex-row align-items-start">
              <span class="preference">
                <label for="from" class="flex-grow outOfOffice pt5">Enable Calendar</label>
              </span>
              <span class="radio-notification">
                <p-inputSwitch formControlName="calendarSubscribed"
                  [styleClass]="'advance-inputSwitch mar-0'"></p-inputSwitch>
              </span>
            </div>
          </div>
          <div class="d-flex flex-row mt-3 mrg-lef">
            <div class="w-75 d-flex flex-row align-items-start ">
              <span class="preference">
                <label for="from" class="flex-grow outOfOffice">Exchange Region</label>
              </span>
              <span>
                <p-dropdown [styleClass]="'prime-dd-override'" class="drop-down w-25 group-details-input"
                  optionLabel="name" formControlName="exchDomain" [options]="exchangeRegionList">
                </p-dropdown>
              </span>
            </div>
          </div>
          <div class="d-flex flex-row mt-3 mrg-lef">
            <div class="w-75 d-flex flex-row align-items-start">
              <span class="preference">
                <label for="from" class="flex-grow outOfOffice pt5">Exchange Account Host</label>
              </span>
              <span class="personal-input-span">
                <input type="text" formControlName="exchUrl" placeholder="<Exchange host>/ews/exchange.asmx"
                  class="t-box personal-input" />
                <span class="sub-title">Exchange host is available on your outlook account page.</span><br />
                <span class="sub-title">Example: <strong>XXXXX</strong></span>
              </span>
            </div>
          </div>
          <div class="d-flex flex-row mt-3 mrg-lef">
            <div class="w-75 d-flex flex-row align-items-start">
              <span class="preference">
                <label for="from" class="flex-grow outOfOffice pt5">Password</label>
              </span>
              <span class="personal-input-span">
                <input type="password" formControlName="exchPassword" placeholder="Enter Password..."
                  class="t-box personal-input" />
              </span>
            </div>
          </div>
          <div class="d-flex flex-row mt-3 mrg-lef">
            <div class="w-75 d-flex flex-row align-items-start">
              <span class="preference">
                <label for="from" class="flex-grow outOfOffice pt5">Retype Password</label>
              </span>
              <span class="personal-input-span">
                <input type="password" formControlName="exchPasswordIV" placeholder="Re-Enter Password..."
                  class="t-box personal-input" />
                <span class="sub-title">Type the password configured for your exchange account.</span>
              </span>
            </div>
            <div *ngIf="psf.exchPasswordIV.errors && isSubmitted" class="invalid-feedback">
              <span *ngIf="psf.exchPasswordIV.errors.mustMatch">Passwords must match.</span>
            </div>
          </div>
          <div class="d-flex flex-row mt-3">
            <ag-grid-angular id="subjectFlagwords" style="height: 180px"
              class="ag-theme-balham profile-setting-headerPart agGridSubjectFlagwords"
              [columnDefs]="subjectWordColumnDefs" [rowData]="subjectFlagwords" [suppressHorizontalScroll]="true"
              [modules]="modules" [rowHeight]="30" [headerHeight]="28" (gridReady)="onGridReady($event)">
            </ag-grid-angular>
          </div>
        </p-tabPanel>
       </p-tabView>
       <p-footer class="footer-profile" >
        <div class="footer">
          <button
            pButton
            label="Reset"
            class="cancel-button"
            (click)="resetChanges()"
          ></button>
          <button
            pButton
            [label]="(actTabName === 'Signature' && (showIcons || updatedSign)) || (actTabName === 'Templates' && (showTempIcons || isModifyTemplate)) ? 'Save' : 'Submit'"
            class="submit-button"
            (click)="onSaveUserProfile()"
          ></button>
        </div>
      </p-footer>
    </div>
  </form>
</div>
<!--Error pop up -->
<p-dialog [(visible)]="hasErrors" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'"
  [styleClass]="'contextMenuModal errorModal ModelClose'" [closable]="true" [dismissableMask]="true"
  [baseZIndex]="10000" [closeOnEscape]="true" [style]="{width: '30%'}" (hide)="hasErrors=false">
  <p-header>
    <div class="d-flex flex-row align-items-center justify-content-between">
      <h6 class="success-title">Error Message</h6>
    </div>
  </p-header>
  <div class="success-msg">{{errorMessage}}</div>
</p-dialog>


<!-- [(visible)]="showPopUp" {{'confirmMsgText'}} -->
<!--Confirmation popup window-->
<p-dialog class="border-none" [visible]="showPopUp" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'"
  [styleClass]="'contextMenuModal'" [closable]="false" [dismissableMask]="true" [baseZIndex]="10000"
  [closeOnEscape]="true" [style]="{'max-width':'500px','width':'50%'}">

  <p-header>
    <div class="d-flex flex-row align-items-center justify-content-between  mx-2 mt-1">
      <h6 class="reage-title">Confirm Action</h6>
      <button type="button" (click)="onCancel(actionFieldName)" class="d-flex flex-row close qma-text">
        <img src="assets/Inbox/close_icon_u73.svg" alt="Close">
      </button>
    </div>
  </p-header>
  <div class="reage-body mx-2">
    <form >
      <div class="d-flex w-100 align-items-center justify-content-center">
          <div class="margin-box" [innerHTML]="getFormattedText(confirmMsgText)"></div>
      </div>
    </form>
  </div>
  <p-footer>
    <div class="d-flex flex-row flex-wrap  btn-wrapper px-3  justify-content-center">
      <button type="button" class=" clear-btn1 " (click)="onCancel(actionFieldName)">Cancel</button>
      <button class=" search-btn1" (click)="onConfirm(actionFieldName)">Ok</button>
    </div>
  </p-footer>
</p-dialog>
